import {
  AiSearchGradientIcon,
  CameraConnectedIcon,
  ConnectDevicesIcon,
  LicensePlateIcon,
  SaturationIcon,
} from "@ubnt/icons";
import { IHeroSection } from "pages/LayoutComponents/Hero/Hero.types";
import React from "react";
import { ICondensedFeatureItem } from "pages/LayoutComponents/CondensedFeatureGrid/CondensedFeatureGrid.types";

import heroJpg from "./assets/videos/hero.jpg";
import heroMp4 from "./assets/videos/hero.mp4";
import bullet1Mp4 from "./assets/feature-tiles/bullet-1.mp4";
import bullet1Jpg from "./assets/feature-tiles/bullet-1.jpg";
import bullet2Mp4 from "./assets/feature-tiles/bullet-2.mp4";
import bullet2Jpg from "./assets/feature-tiles/bullet-2.jpg";
import bullet3Mp4 from "./assets/feature-tiles/bullet-3.mp4";
import bullet3Jpg from "./assets/feature-tiles/bullet-3.jpg";
import bullet4Mp4 from "./assets/feature-tiles/bullet-4.mp4";
import bullet4Jpg from "./assets/feature-tiles/bullet-4.jpg";

export const HERO_SECTIONS = [
  {
    id: 0,
    icon: <ConnectDevicesIcon size="original" color="#fff" />,
    label: "Discreet<br>and Compact",
    poster: heroJpg,
    src: heroMp4,
    playbackTimeInSeconds: 28,
  },
] satisfies IHeroSection[];

export const FEATURE_COMPLETE_TILES = [
  {
    id: "6th-gen-optics",
    assets: {
      src: bullet1Mp4,
      poster: bullet1Jpg,
      icon: <CameraConnectedIcon size={50} color="#3B3F45" />,
    },
    variant: "dark",
    title: "cameraSecurity.bullet.featureTiles.6thGenOptics.title",
    description: "cameraSecurity.bullet.featureTiles.6thGenOptics.description",
    isSelectedModelsOnly: true,
  },
  {
    id: "optimized-for-lpr",
    assets: {
      src: bullet2Mp4,
      poster: bullet2Jpg,
      icon: <LicensePlateIcon size={50} color="#3B3F45" />,
    },
    variant: "dark",
    title: "cameraSecurity.bullet.featureTiles.optimized.title",
    description: "cameraSecurity.bullet.featureTiles.optimized.description",
  },
  {
    id: "ai-engine",
    assets: {
      src: bullet3Mp4,
      poster: bullet3Jpg,
      icon: <AiSearchGradientIcon size={50} color="#3B3F45" />,
    },
    variant: "dark",
    title: "cameraSecurity.bullet.featureTiles.aiEngine.title",
    description: "cameraSecurity.bullet.featureTiles.aiEngine.description",
    isSelectedModelsOnly: true,
  },
  {
    id: "weatherproof-enclosure",
    assets: {
      src: bullet4Mp4,
      poster: bullet4Jpg,
      icon: <SaturationIcon size={50} color="#3B3F45" />,
    },
    variant: "dark",
    title: "cameraSecurity.bullet.featureTiles.weatherproof.title",
    description: "cameraSecurity.bullet.featureTiles.weatherproof.description",
  },
] satisfies Array<ICondensedFeatureItem>;
